import { ValidationService } from './../../../shared/services/validation.service';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { VaccineService } from './vaccine.service';
import { MdDialogRef, MD_DIALOG_DATA, MdOption } from '@angular/material';
import { VaccineStockModel } from '../../../models/master-data/vaccine-stock.model';
import { AppMessages } from '../../../shared/constants/messages';
import { CurrencyNumberDirective } from '../../../directives/currency-number.directive';
import { CurrencyNumberPipe } from '../../../pipes/currency-number.pipe';
import { AppConstants } from '../../../shared/constants/constants';

@Component({
    selector: 'modify-vaccine-popup',
    templateUrl: 'modify-vaccine-popup.component.html',
    providers: [VaccineService,CurrencyNumberPipe, CurrencyNumberDirective]
})

export class ModifyVaccinePopupComponent implements OnInit {
    public vaccineForm: FormGroup;
    public modifyVaccineModel = new VaccineStockModel();
    public title: string;
    public defaultCourseData = [];
    public supplierData = [];
    public listDefaultCourse: any;
    public listSupplier: any;
    public isSuccess = false;
    public generalInfoVaccineMaxLength = 6000;
    centres = JSON.parse(localStorage.getItem(AppConstants.localStorage.centres));
    currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);
    selectAll = {centreId: '00000000-0000-0000-0000-000000000000', centreName: 'Apply to all'}
    @ViewChild('allSelected') public allSelected: MdOption;

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private vaccineService: VaccineService,
        public dialogRef: MdDialogRef<ModifyVaccinePopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {
          this.createForm();
        }

    ngOnInit() {
      if (this.data.id) {
        this.title = 'Update Vaccine';
        this.getVaccine(this.data.id);
      } else {
        this.title = 'Add Vaccine';
        this.modifyVaccineModel.centreIds = [this.currentCentreId];
      }
        this.defaultCourseData = this.vaccineService.getDefaultCourseData();
        this.vaccineService.getSuppliers().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.supplierData = data['list'];
                }
            }
        );

    }

    createForm() {
        this.vaccineForm = this.formBuilder.group({
            name: ['', [Validators.required]],
            brand: ['', [Validators.required]],
            adultDose: ['', [Validators.required]],
            route: ['', [Validators.required]],
            monthExpectedCover: ['', [Validators.required, this.isValidExpectedCover]],
            boosterCourse: ['', [Validators.required, ValidationService.isValidNumber0To999]],
            primaryCourse: ['', [Validators.required, ValidationService.isValidNumber0To999]],
            fromAge: [null, [Validators.required, ValidationService.isValidNumberFromTo(0, 200)]],
            toAge: [null, [Validators.required, ValidationService.isValidNumberFromTo(0, 200)]],
            //isDefault: '',
            generalInformation: '',
            defaultCourse: ['', [Validators.required]],
            supplierId: [''],
            costPrice: [''],
            medicalInformation: '',
            centreIds: ['', [Validators.required]],
            vaccineId: ['']
        });
    }

    tosslePerOne() {
      if (this.allSelected.selected) {
        this.allSelected.deselect();
        let updatedValues = this.vaccineForm.controls.centreIds.value.filter(value => value !== this.selectAll.centreId);
        this.vaccineForm.controls.centreIds.setValue(updatedValues);
        return false;
      }
      if (this.vaccineForm.controls.centreIds.value.length == this.centres.length)
      {
        this.allSelected.select();
        let currentValues = this.vaccineForm.controls.centreIds.value;
        let updatedValues = [...currentValues, this.selectAll.centreId];
        this.vaccineForm.controls.centreIds.setValue(updatedValues);
      }
    }
    toggleAllSelection() {
      if (this.allSelected.selected) {
          this.vaccineForm.controls.centreIds.patchValue([...this.centres.map(item => item.centreId), this.selectAll.centreId]);
        } else {
            this.vaccineForm.controls.centreIds.patchValue([]);
        }
    }

    isValidExpectedCover(control: AbstractControl) {
        const number = Number(control.value);
        if (number < 0 || number > 2147483647) {
            return { 'invalidCover': true };
        }
        return null;
    }

    // acceptNumberOnly(event: any){
    //     const pattern = /[0-9]/;
    //     const inputChar = String.fromCharCode(event.charCode);
    //     if(!pattern.test(inputChar)){
    //         event.preventDefault();
    //     }
    // }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    getVaccine(id) {
        this.vaccineService.getVaccine(id).subscribe(
            (result) => {
                const data = result.json();
                this.modifyVaccineModel = data;
                this.modifyVaccineModel.centreIds = [this.currentCentreId];
            }, (error) => { }
        );
    }

    editVaccine() {

      this.vaccineService.updateVaccine(this.data.id, this.vaccineForm.value).subscribe(
          (result) => {
              if (result) {
                  const data = result.json();
                  this.dialogService.openSuccessDialog({ message: data.message });
                  this.isSuccess = true;
                  this.close();
              }
          }
      );
    }

    addVaccine() {
        this.vaccineService.addNewVaccine(this.vaccineForm.value).subscribe(
            result=>{
                if(result)
                {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({message : data.message});
                    this.isSuccess = true;
                    this.close();
                }
            }
        );
    }

    onSubmit() {
        if (this.vaccineForm.valid) {
            // Edit vaccine if vaccine id exist, if not add vaccine
            if (this.modifyVaccineModel.id) {
              this.editVaccine();
            } else {
              this.addVaccine();
            }
        }
    }


}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/vaccine/modify-vaccine-popup.component.ts